import React from 'react';

import FormikInput from "components/input/new/FormikInput";

function ContactPhoneNumberField(props) {
    return (
        <FormikInput
            name={'contactPhoneNumber'}
            label={'shippingMethods.form.field.contactPhoneNumber.label'}
            placeholder={'shippingMethods.form.field.contactPhoneNumber.placeholder'}
            required={true}
        />
    );
}

export default ContactPhoneNumberField;
